import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchResults } from '../searchResults';
import { Ship } from './ship';

@JsonObject('ShipSearchResults')
export class ShipSearchResults extends SearchResults {
    @JsonProperty('results', [Ship])
    results: Ship[] = [];
}
